import CommonAPIService from "src/serviceHandlers/commonHandler";
import router from "@/routes/routes";

const api = new CommonAPIService(router);
const base = "/api/conversations";
const messagesBase = "/api/messages";

export const conversationsService = {
  // List user's conversations
  list: (params) => api.getCall(base, params),

  // Get single conversation details
  getById: (id) => api.getCall(`${base}/${id}`),

  // Create a new conversation
  create: (payload) => api.postCall(base, payload),

  // Update conversation (name for groups)
  update: (id, payload) => api.putCall(`${base}/${id}`, payload),

  // Leave/delete conversation
  delete: (id) => api.deleteCall(`${base}/${id}`),

  // Get paginated messages for a conversation
  getMessages: (conversationId, params) =>
    api.getCall(`${base}/${conversationId}/messages`, params),

  // Send a message
  sendMessage: (conversationId, payload) =>
    api.postCall(`${base}/${conversationId}/messages`, payload),

  // Send a message with file attachments (multipart/form-data)
  sendMessageWithAttachments: (conversationId, content, files) => {
    const formData = new FormData();
    formData.append("content", content || "");
    files.forEach((f) => formData.append("files", f));
    return api.postFormDataCall(`${base}/${conversationId}/messages`, formData);
  },

  // Add participants to a group conversation
  addParticipants: (conversationId, payload) =>
    api.postCall(`${base}/${conversationId}/participants`, payload),

  // Remove participant from a group conversation
  removeParticipant: (conversationId, userId) =>
    api.deleteCall(`${base}/${conversationId}/participants/${userId}`),

  // Get or create direct conversation with a user
  getOrCreateDirect: (userId) => api.getCall(`${base}/direct/${userId}`),

  // Get total unread message count
  getUnreadCount: () => api.getCall(`${base}/unread-count`),

  // Mark conversation as read
  markAsRead: (conversationId) =>
    api.postCall(`${base}/mark-read/${conversationId}`),

  // Edit a message (within 5-minute window)
  editMessage: (messageId, payload) =>
    api.putCall(`${messagesBase}/${messageId}`, payload),
};

export default conversationsService;
